module.exports = { "default": require("core-js/library/fn/object/get-own-property-descriptors"), __esModule: true };